<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
//import "../node_modules/uview-ui/index.scss";
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    /* async adminhome() {
      const user = await this.$http.get("/");
      console.log(user);
    }, */
  },
  created() {
    //this.adminhome();
  },
};
</script>
